<template>
  <div class="animated fadeIn">
    <!-- <b-row>
      <b-col lg="6">
        <b-card>
          <h3 class="text-shoppingCartGray">
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Name }}
          </h3>

          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Address1 }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Address2 }}
          </h5>
          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.City }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.State }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.PostalCode }}
          </h5>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card>
          <h3 class="text-shoppingCartGray">
            PO # {{ campaign.campaign_roi.CampaignStatHeader.PONumber }}
          </h3>

          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.campaign_name }}
          </h5>
          <h5>
            Broadcast Date:
            {{ campaign.campaign_roi.CampaignStatHeader.broadcast_date }}
          </h5>
        </b-card>
      </b-col>
    </b-row> -->
    <b-row class="mb-4">
      <b-col lg="6">
        <!-- <b-card>
          <h3 class="text-shoppingCartGray">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </h3>

          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </h5>
          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </h5>
        </b-card> -->

        <div class="return-address">
          <p class="company-name">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }},
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </p>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="return-address">
          <p class="company-name">
            PO # {{ campaign.campaign_report.CampaignHeader.PONumber }}
          </p>

          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.campaign_name }}
          </p>
          <p class="address-line">
            Broadcast Date:
            {{ campaign.campaign_report.CampaignHeader.broadcast_date }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(1)"
          ><h3 class="mb-4">
            Activity & Analytics
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(2)"
          ><h3 class="mb-4">
            Performance & ROI
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" disabled
          ><h3 class="mb-4">
            Summary & Charts
          </h3></b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="2">
        <b-card class="summaryStats">
          EMAILS<br />
          <span class="stats-highlight">
            {{ with_comma(campaign.campaign_report.CampaignHeader.quantity) }}
          </span>
        </b-card>
      </b-col>
      <b-col lg="2">
        <b-card class="summaryStats">
          OPENED<br />
          <span class="stats-highlight">
            {{
              as_percentage(campaign.campaign_report.CampaignHeader.opens_pc)
            }}
          </span>
          <span style="display: block;">
            ({{ with_comma(campaign.campaign_report.CampaignHeader.opens) }})
          </span>
        </b-card>
      </b-col>
      <b-col lg="2">
        <b-card class="summaryStats">
          CLICKED<br />
          <span class="stats-highlight">
            {{
              as_percentage(campaign.campaign_report.CampaignHeader.clicks_pc)
            }}
          </span>
          <span style="display: block;">
            ({{ with_comma(campaign.campaign_report.CampaignHeader.clicks) }})
          </span>
        </b-card>
      </b-col>
      <b-col lg="2">
        <b-card class="summaryStats">
          SERVICE ROI<br />
          <span class="stats-highlight service">
            {{
              as_dollar(
                campaign.campaign_roi.ServiceRevenue /
                  campaign.campaign_roi.CampaignStatHeader.Investment
              )
            }}
            : $1.00
          </span>
        </b-card>
      </b-col>
      <b-col lg="2">
        <b-card class="summaryStats">
          SALES ROI<br />
          <span class="stats-highlight sales">
            {{
              as_dollar(
                campaign.campaign_roi.SalesRevenue /
                  campaign.campaign_roi.CampaignStatHeader.Investment
              )
            }}
            : $1.00
          </span>
        </b-card>
      </b-col>
      <b-col lg="2">
        <b-card class="summaryStats">
          TOTAL ROI<br />
          <span class="stats-highlight">
            {{
              as_dollar(
                (campaign.campaign_roi.SalesRevenue +
                  campaign.campaign_roi.ServiceRevenue) /
                  campaign.campaign_roi.CampaignStatHeader.Investment
              )
            }}
            : $1.00
          </span>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12"> </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <ServiceSalesByDateLine />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ServiceSalesByDateLine from "@/charts/ServiceSalesByDateLine.vue";

export default {
  name: "CampaignVisual",
  data() {
    return {
      percentageOptions: {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      USDollarFormat: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      })
    };
  },
  created() {
    this.myLoadComponent();
  },
  methods: {
    loadOtherReport(reportID) {
      if (reportID == 1) {
        this.$router.push({ name: "CampaignReport" });
      }
      if (reportID == 2) {
        this.$router.push({ name: "CampaignROI" });
      }
      if (reportID == 3) {
        this.$router.push({ name: "CampaignVisual" });
      }
    },
    with_comma(number) {
      return new Intl.NumberFormat().format(number);
    },
    back() {
      this.$router.go(-1);
    },
    as_percentage(number) {
      return new Intl.NumberFormat(undefined, this.percentageOptions).format(
        number
      );
    },
    as_dollar(number) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(number);
    },
    DashRouteTo(_page) {
      this.$router.push(_page);
    },
    async myLoadComponent() {
      await this.$store.dispatch(
        "campaign/loadCampaignROI",
        this.$store.state.campaign.campaign_report.CampaignHeader.PONumber
      );
    }
  },
  computed: {
    ...mapState(["campaign", "dealer", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"])
  },
  components: {
    ServiceSalesByDateLine
  },

  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
.my-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.05) !important;
  color: #850101;
  padding-top: 4px;
}
.my-other-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.15) !important;
  color: #850101;
  padding-top: 4px;
}
.btn-link:disabled,
.btn-link.disabled {
  color: #000;
  font-weight: bold;
  pointer-events: none;
  text-decoration: underline;
}
</style>
